import React from 'react';

const AdminMainPart = ({ children, adminSideDrawer }) => {
    return (
        <main className="db-main" dir={adminSideDrawer ? 'ltr' : ''}>
            {children}
        </main>
    );
};

export default AdminMainPart;
